import React from 'react';
import { withRouter } from 'react-router-dom';
import { parse, isValid } from 'date-fns';

import { withFormik } from 'formik';
import * as yup from 'yup';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import Input from '../../../../components/Input/Input';
import SchedulePreview from '../SchedulePreview';

const styles = theme => ({
  button: {
    display: 'inherit',
    margin: `${theme.spacing(2)}px auto`,
    minWidth: '300px',
    minHeight: '50px',
  },
});

const Form = (props) => {
  const {
    values,
    schedules,
    errors,
    touched,
    handleChange,
    handleBlur,
    setFieldValue,
    returning,
  } = props;

  const formFields = [
    {
      elementType: 'select',
      config: {
        name: 'scheduleId',
        label: 'Escala',
        required: true,
        options: schedules.map(schedule => ({
          value: schedule.workingDay.id,
          displayValue: schedule.workingDay.description,
        })),
      },
      helperText: ' ',
    },
    {
      elementType: 'datePicker',
      config: {
        name: 'scheduleStartDate',
        label: 'Início da Escala',
        required: true,
        isFormik: true,
      },
      helperText: 'A data deve coincidir com o primeiro dia do ciclo de revezamento',
    },

  ];

  if (returning) {
    props.setReturning(false);
    props.formValues(values);
  }

  if (props.formValues) {
    props.formValues(values);
  }

  if (props.submit && props.submit.toggle) {
    props.setSubmit({ event: null, toggle: false });
    props.handleSubmit(props.submit.event);
  }

  if (props.setScheduleIsValid) {
    props.setScheduleIsValid(Object.entries(props.errors).length === 0 && props.errors.constructor === Object);
  }
  
  // console.log('scheduleId',values.scheduleId)
  const scheduleId = values.scheduleId
  const scheduleRotation = schedules.filter(schedule => schedule.workingDay.id === values.scheduleId)
  const isRotation = scheduleId > 0 && schedules.length ? scheduleRotation.length > 0 ?schedules.filter(schedule => schedule.workingDay.id === scheduleId)[0].workingDay.isRotation : false : false;
  return (
    <form onSubmit={(e) => { e.preventDefault(); }} style={{ width: '100%' }}>
      <Grid item container spacing={2}>
        {formFields.map(field => (
          <Grid item xs={12} sm={6} key={field.config.name}>
            <Input
              {...field.config}
              elementType={field.elementType}
              value={values[field.config.name]}
              onChange={field.elementType === 'datePicker' ? setFieldValue : handleChange}
              onBlur={handleBlur}
              fullWidth
              margin="normal"
              error={errors[field.config.name] && touched[field.config.name]}
              helperText={field.elementType === 'datePicker' && isRotation ? field.helperText : null}
            />
          </Grid>
        ))}
        {
          scheduleId > 0 && schedules.length ?
            <SchedulePreview schedule={scheduleRotation.length > 0 ?schedules.filter(schedule => schedule.workingDay.id === scheduleId)[0] : false} /> :
            null
        }
      </Grid>
      {
        props.innerSubmit ? (
          <Grid item container justify="flex-end" spacing={1} >
            <Button
              onClick={props.close}
              style={{ marginRight: 10, marginTop: 10, marginBottom: 20 }}
            >
              FECHAR
            </Button>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              onClick={props.handleSubmit}
              style={{ marginTop: 10, marginBottom: 20 }}
            >
              SALVAR
            </Button>
          </Grid>
        ) : null
      }

    </form>
  );
};

const initializeItemForm = item => item || '';
const initializeDateForm = (item) => {
  if (isValid(item)) {
    return item;
  }
  return (item ? parse(item, 'yyyy-MM-dd', new Date()) : null);
};

const ScheduleForm = withFormik({
  enableReinitialize: false,
  mapPropsToValues: props => ({
    scheduleId: initializeItemForm(props.data.scheduleId),
    scheduleStartDate: initializeDateForm(props.data.scheduleStartDate),
  }),
  validationSchema: yup.object().shape({
    scheduleStartDate: yup.string().required(),
    scheduleId: yup
      .number()
      .integer()
      .required(),
  }),
  handleSubmit: (values, { props }) => {
    if (props.innerSubmit) {
      props.updateEmployee(values.scheduleStartDate, values.scheduleId);
      props.close();
    } else {
      props.formValues(values);
      props.setFormsStatus({ ...props.formsStatus, schedule: true });
    }
  },
})(Form);

export default withStyles(styles)(withRouter(ScheduleForm));
